import React from 'react';
import PropTypes from 'prop-types';

import TopLineTitle from '../atoms/titles/TopLineTitle';
import Tag from '../atoms/tag/Tag';
import TextLink from '../atoms/link/Textlink';
import Caution from '../molecules/Caution';

const FacilityDetail = ({ hotel, hideDetailLink }) => {
  if (!hotel) {
    return null;
  }

  const {
    name,
    recommendationPoint,
    picsURL,
    access,
    tags,
    detailURL,
    mapURL,
    area,
    message,
    specialMeasures,
  } = hotel;


  // workaround https://gitlab.fqsv.net/dp-plus/front/issues/104 cant use <a>tag
  const onClickDetailLink = () => window.open(detailURL, '_blank');

  return (
    <div className="FacilityDetail">
      <TopLineTitle
        name={name}
        area={`${area.prefectureName}/${area.areaName}`}
        hideDetailLink={hideDetailLink}
        onClickDetailLink={onClickDetailLink}
      />
      <div className="FacilityInfo">
        <div className="thumbnail">
          <div className="thumbnailImage">
            <img src={picsURL} alt="" />
          </div>
          {specialMeasures && (
            <div>
              <link href="https://ecwww9.nta.co.jp/test_search/style.css" rel="stylesheet" media="all" />
              <ul className="pr_label">
                <li className="pr_icon_01">{specialMeasures}</li>
              </ul>
            </div>
          )}
        </div>
        <div className="detail">
          <p dangerouslySetInnerHTML={{ __html: recommendationPoint }} />
          <div className="access">
            <div className="title">アクセス</div>
            <div
              className="accessList"
              dangerouslySetInnerHTML={{ __html: access }}
            />
            <div className="facilityDetailTagItems">
              {tags.map((c) => (
                <div key={c.id} className="tagItem">
                  <Tag>{c.name}</Tag>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <Caution message={message} />
    </div>
  );
};

FacilityDetail.defaultProps = {
};

FacilityDetail.propTypes = {
  hotel: PropTypes.object,
  hideDetailLink: PropTypes.bool,
};

export default FacilityDetail;
